import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { selectGameStatusObject } from '../../gamestate/gameStateSlice';
import { selectPlayer } from '../../player/playerSlice';
import CategoryList from './CategoryList';

// Define brand colors
const TEXT_COLOR = '#222';

const Root = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(2),
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: `max(${theme.spacing(2)}, env(safe-area-inset-top))`,
  paddingBottom: `max(${theme.spacing(2)}, env(safe-area-inset-bottom))`,
  paddingLeft: `max(${theme.spacing(2)}, env(safe-area-inset-left))`,
  paddingRight: `max(${theme.spacing(2)}, env(safe-area-inset-right))`,
}));

const Header = styled(Typography)(({ theme }) => ({
  fontFamily: "'Gyparody', 'Bangers', 'Impact', sans-serif",
  fontSize: '1.75rem',
  fontWeight: 800,
  color: TEXT_COLOR,
  marginBottom: theme.spacing(2),
  textAlign: 'center',
  textShadow: '1px 1px 0px rgba(46, 196, 182, 0.3)',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.5rem',
  },
}));

const ContentContainer = styled(Container)(({ theme }) => ({
  maxWidth: '600px',
  width: '100%',
  padding: theme.spacing(2),
  backgroundColor: '#fff',
  borderRadius: theme.spacing(2),
  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
  },
  marginTop: `max(${theme.spacing(2)}, env(safe-area-inset-top))`,
  marginBottom: `max(${theme.spacing(2)}, env(safe-area-inset-bottom))`,
}));

const ClueSelector = () => {
  const gameState = useSelector(selectGameStatusObject);
  const player = useSelector(selectPlayer);

  // Check if this player is in control
  const isPlayerInControl = player && gameState.playerInControl === player.id;

  if (!isPlayerInControl) {
    return (
      <Root>
        <ContentContainer>
          <Header>Waiting for your turn...</Header>
          <Typography align="center" color="textSecondary">
            Another player is selecting the next clue.
          </Typography>
        </ContentContainer>
      </Root>
    );
  }

  return (
    <Root>
      <ContentContainer>
        <Header>You're in control!</Header>
        <Typography 
          align="center" 
          color="textSecondary" 
          sx={{ mb: 3 }}
        >
          Select a category to choose your next clue.
        </Typography>
        <CategoryList />
      </ContentContainer>
    </Root>
  );
};

export default ClueSelector; 